import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IAminityState } from '../../types/features/aminitySlice';
import { IAminityApiResponse, IAminityData } from '../../types/api/aminityApi';
import { getAminityDataService } from '../../api/aminityApi';

export const getAminityData = createAsyncThunk<IAminityApiResponse>(
    'aminity/getAminityData',
    async () => {
        const response = await getAminityDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

const aminitySlice = createSlice({
    name: 'aminity',
    initialState: {
        aminityLoader: false,
        status: false,
        msg: '',
        aminities: [],
        more_aminities: []
    } as IAminityState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAminityData.pending, (state) => {
                state.aminityLoader = true;
            })
            .addCase(getAminityData.fulfilled, (state, action: PayloadAction<IAminityApiResponse>) => {
                let aminityData = action.payload.data;
                if (aminityData && aminityData.length > 0) {
                    state.aminities = aminityData.filter((val: IAminityData) => val.is_more !== true);
                    state.more_aminities = aminityData.filter((val: IAminityData) => val.is_more === true);
                }
                state.msg = action.payload.message;
                state.status = true;
                state.aminityLoader = false;
            })
            .addCase(getAminityData.rejected, (state, action) => {
                state.aminityLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })

    }
});

export default aminitySlice.reducer;
